<template>
    <div class="notice">
        <h1 class="title">注意事項</h1>
        <div class="group" v-if="hasRules">
            <div class="title">
                使用規範
            </div>
            <div class="content">
                <!-- <img src="@/assets/img/shareHouse/prohibit.svg" alt="" srcset=""> -->
                {{getHouseSetting(rules)}}
            </div>
        </div>
        <div class="group" v-if="hasRentInclude">
            <div class="title">
                租金包含項目
            </div>
            <div class="content">
                {{getHouseSetting(rentInclude)}}
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    methods: {
        // getHouseSetting: function (arr) {
        //     let text = ''
        //     arr.map( (item, index) => {
        //         if(item.check == true){
        //             text += item.itemName+ '、'
        //         }
        //     })
        //     return text.substring(0,text.length-1)
        // },
    },
    computed: {
        hasRules: function () {
            let hasRules = false
            if(this.rules.length > 0){
                this.rules.map( (item, index) => {
                    if(item.check == true){
                        hasRules = true
                    }
                })
                return hasRules
            }
        },
        hasRentInclude: function () {
            let hasRentInclude = false
            if(this.rentInclude.length > 0){
                this.rentInclude.map( (item, index) => {
                    if(item.check == true){
                        hasRentInclude = true
                    }
                })
                return hasRentInclude
            }
        },
        ...mapGetters({
            rentInclude: 'GET_SHARE_HOUSE_RENT_INCLUDE',
            rules: 'GET_SHARE_HOUSE_RULES',
        })
    },
}
</script>
<style lang="scss" scoped>
    .notice{
        position: relative;
        width: 100%;
        margin-bottom: -25px;
        h1.title{
            margin-bottom: 20px;
            font-size: 28px;
            color: #3a455f;
        }
        .group{
            margin-bottom: 25px;
            .title{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 10px;
            }
            .content{
                display: flex;
                align-items: center;
                font-size: 16px;
                line-height: 1.5;
                img{
                    margin-right: 10px;
                }
            }
        }
    }
    @media (max-width: 992px) {
        .notice{
            h1.title{
                margin-bottom: 16px;
                font-size: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/notice.vue